import { StarHalfFullIcon } from './StarHalfFullIcon';

/**
 * author: Google
 * id 52E97617-C7F4-45D0-98E0-E9B4407EC179
 * name star-half-full
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-half-full.svg
 * tags
 */
export const FavoriteHalfFullIcon = StarHalfFullIcon;
export default FavoriteHalfFullIcon